import type { TransitStop } from '../types/stop.types';
import { PointEntityDetailsPanel } from '../../../spatial/components/PointEntityDetailsPanel';
import {
  getStopLabel,
  getStopTypeName,
} from '../types/stop.types';

export interface TransitStopDetailsPanelProps {
  stop: TransitStop;
  onClose: () => void;
}

function formatRoutes(stop: TransitStop): string {
  return stop.metadata?.routes?.length
    ? stop.metadata.routes.join(', ')
    : 'Sin rutas asociadas';
}

export function TransitStopDetailsPanel({
  stop,
  onClose,
}: TransitStopDetailsPanelProps): JSX.Element {
  return (
    <PointEntityDetailsPanel
      title="Parada"
      code={stop.code}
      subtitle={getStopLabel(stop, { includeCode: false })}
      projectId={stop.projectId}
      entityType="transit_stop"
      entityId={stop.id}
      coordinates={stop.geometry.coordinates as [number, number]}
      onClose={onClose}
      fields={[
        { label: 'Tipo', value: getStopTypeName(stop.type) },
        { label: 'Accesible', value: stop.accessible ? 'Sí' : 'No' },
        { label: 'Rutas', value: formatRoutes(stop) },
        { label: 'Semana', value: stop.metadata?.schedule?.weekday || 'Sin definir' },
        { label: 'Fin de semana', value: stop.metadata?.schedule?.weekend || 'Sin definir' },
        { label: 'Amenidades', value: stop.metadata?.amenities?.join(', ') || 'Sin definir' },
        { label: 'Ubicación', value: `${stop.geometry.coordinates[0].toFixed(6)}, ${stop.geometry.coordinates[1].toFixed(6)}` },
      ]}
    />
  );
}
